import React, { useState, useRef, useLayoutEffect } from 'react';
import { createPortal } from 'react-dom'; // Import createPortal
import './ToolTip.css';

export const Tooltip = ({ children, tip }) => {
  const triggerRef = useRef(null);
  const tooltipRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  // Use useLayoutEffect to calculate position before the browser paints
  useLayoutEffect(() => {
    if (visible && triggerRef.current && tooltipRef.current) {
      const triggerRect = triggerRef.current.getBoundingClientRect();
      const tooltipRect = tooltipRef.current.getBoundingClientRect();
      const viewportWidth = window.innerWidth;

      // Default position: centered above the trigger element
      let top = triggerRect.top - tooltipRect.height - 8; // 8px gap
      let left = triggerRect.left + (triggerRect.width / 2) - (tooltipRect.width / 2);

      // --- Boundary Checks and Adjustments ---

      // Adjust left position if it goes off-screen
      if (left < 8) { // 8px padding from edge
        left = 8;
      } else if (left + tooltipRect.width > viewportWidth - 8) {
        left = viewportWidth - tooltipRect.width - 8;
      }

      // Flip to below if it goes off the top of the screen
      if (top < 8) {
        top = triggerRect.bottom + 8;
      }
      
      setPosition({ top, left });
    }
  }, [visible, tip]); // Recalculate if visibility or content changes

  const tooltipElement = (
    <div
      ref={tooltipRef}
      className={`tooltip-box ${visible ? 'visible' : ''}`}
      style={{ top: `${position.top}px`, left: `${position.left}px` }}
    >
      {tip}
    </div>
  );

  return (
    <div
      ref={triggerRef}
      className="tooltip-wrapper"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {/* Render the tooltip in a portal attached to the body */}
      {visible && createPortal(tooltipElement, document.body)}
    </div>
  );
};